import React from "react"; //as of 7/10/2020
import ReactDOM from "react-dom";
import {BrowserRouter} from "react-router-dom";
import App from "./App/App";
import rootReducer from "./Store/RootReducer";
import {Provider} from "react-redux";
const redux = require("redux");

const store = redux.createStore(rootReducer);

const mainApp=(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
   
)

ReactDOM.render(mainApp , document.getElementById("app"));